module.exports = __webpack_public_path__ + "media/images/tyre-guide-aca5fdc167775d9f401aed56d087edde.jpg";